<template>
  <div class="side-bar-small">
    <div class="title-background">
      <div></div>
    </div>
    <div class="title">
      <b-button v-b-toggle.sidebar-small><b-img :src="menuSvg" /></b-button>
      <div class="name"><h1>Thuy B. Nguyen</h1></div>
    </div>
      <b-sidebar id="sidebar-small" bg-variant="none" no-header>
        <b-nav vertical>
            <div class="author">
                <figure>
                    <b-img fluid :src="image"></b-img>
                </figure>
                <h2>Thuy B. <br/>Nguyen</h2>
            </div>
            <b-nav-item href="#about"><b-icon icon="person-fill"></b-icon> About</b-nav-item>
            <b-nav-item href="#projects"><b-icon icon="layout-text-window-reverse"></b-icon> Projects</b-nav-item>
            <b-nav-item href="#skills"><b-icon icon="bar-chart-fill"></b-icon> Skills</b-nav-item>
            <b-nav-item href="#experience"><b-icon icon="graph-up"></b-icon> Experience</b-nav-item>
            <b-nav-item href="#education"><b-icon icon="book"></b-icon> Education</b-nav-item>
            <b-nav-item href="#hobbies"><b-icon icon="binoculars"></b-icon> Hobbies</b-nav-item>
            <b-nav-item href="#contact"><b-icon icon="mailbox2"></b-icon> Contact</b-nav-item>
            <b-nav-item href="/resume.pdf"><b-icon icon="printer-fill"></b-icon> Resume</b-nav-item>
        </b-nav>
      </b-sidebar>
  </div>
</template>

<script>
import ThuyJpg from '../assets/resume/thuy.jpg'
import listSvg from '../assets/list.svg'

export default {
    data () {
        return {
            image: ThuyJpg,
            menuSvg: listSvg,
        }
    },
}
</script>

<style lang="scss" scoped>
// /* @import '../styles/components/SideBarSmall.scss' */
</style>
